import { HttpRequest } from "../../api/core/request/HttpRequest";
import { RequestConstants } from "../../api/core/request/RequestConstants";
import { EventHandler } from "../../util/event/EventHandler";
/*
 * ImageRequest.ts
 */
export class ImageRequest {
    constructor(url) {
        this.url = url;
    }
    onComplete(handler, scope) {
        this.completeHandler = new EventHandler(handler, scope);
    }
    load() {
        this.request = new HttpRequest(RequestConstants.GET, this.url);
        this.request.setContentType(RequestConstants.APPLICATION_XML);
        this.request.setResponseType(RequestConstants.TEXT);
        this.request.onComplete(this.handleComplete, this);
        this.request.onError(this.handleError, this);
        this.request.send();
    }
    handleComplete() {
        this.completeHandler.call(this);
    }
    handleError() {
        this.completeHandler.call(this);
    }
    getResponseText() {
        return this.request.getRequest().responseText;
    }
}
//# sourceMappingURL=ImageRequest.js.map